export default angular
  .module("CodeSystemCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("CodeSystemController", [
    "$scope",
    "$stateParams",
    "$rootScope",
    "CodeSystem",
    "System",
    function (
      $scope,
      $stateParams,
      $rootScope,
      CodeSystem,
      System,
    ) {
      $rootScope.page = "code-system";
      $scope.codeSystem = undefined;

      $scope.supportedGroups = [];

      $rootScope.changedFields = new Map();
      $scope.changedField = (entity) => {
        $rootScope.changedFields.set(entity, true);
      };

      $scope.suggestGroups = function (query) {
        return $scope.supportedGroups.filter(group => (
          group.NAME.toLowerCase().indexOf(query.toLowerCase()) !== -1
        ));
      };

      const openCodeSystem = (codeSystemId) => {
        $rootScope.changedFields = new Map();
        $rootScope.page = "codeSystemDetails";
        $rootScope.pageId = codeSystemId;
        $scope.codeSystem = undefined;

        CodeSystem.loadCodeSystemById(codeSystemId, (data) => {
          System.loadCodeSystemGroups((countries) => {
            $scope.codeSystem = data;

            $scope.supportedGroups = countries;
            $scope.supportedGroups.push({ ID: -1, NAME: "All" });

            if ($scope.codeSystem.ALL_GROUPS === 1) {
              $scope.codeSystem.GROUPS =
                [$scope.supportedGroups[$scope.supportedGroups.length - 1]];
            }
          });

          $("#code-system-list-content").collapse("hide");
        });
      };

      const codeSystemId = $stateParams.id;
      if (codeSystemId) {
        openCodeSystem(codeSystemId);
      }
    },
  ]);
